import React from "react";
import { Box, Typography, DialogTitle, DialogContent } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import { IconButton } from "@ui";
import { DigitalLender, CustomerDeclarationEntry } from "@/shared/api/types";
import { LenderParentRecord } from "@/shared/api/services/lenderService";
import AddCompanyForm, { Company } from "@/components/AddCompanyForm";

interface AddCompanyDialogProps {
  onClose: () => void;
  ieMstrLenderData: LenderParentRecord[];
  digitalLenders: DigitalLender[];
  setCompanies?: React.Dispatch<React.SetStateAction<Company[]>>;
  freepostCreditorNamesData: DigitalLender[];
  declarationData: CustomerDeclarationEntry[];
  setCompanyShareLastUpdateDate?: React.Dispatch<React.SetStateAction<number>>;
  source: string;
  companies?: Company[];
  balanceAmount?: number;
}

const AddCompanyDialog: React.FC<AddCompanyDialogProps> = ({
  onClose,
  ieMstrLenderData: _ieMstrLenderData,
  digitalLenders,
  setCompanies,
  freepostCreditorNamesData,
  declarationData,
  setCompanyShareLastUpdateDate,
  source,
  companies,
  balanceAmount,
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* Dialog Title */}
      <DialogTitle
        sx={{
          borderBottom: "1px solid #e0e0e0",
          px: 4,
          justifyContent: "space-between",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          Add Company
        </Typography>

        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: "#9ca3af",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Dialog Content */}
      <DialogContent sx={{ pt: 3, px: 4, flexGrow: 1, overflowY: "auto" }}>
        <AddCompanyForm
          ieMstrLenderData={_ieMstrLenderData}
          digitalLenders={digitalLenders}
          setCompanies={setCompanies}
          freepostCreditorNamesData={freepostCreditorNamesData}
          declarationData={declarationData}
          setCompanyShareLastUpdateDate={setCompanyShareLastUpdateDate}
          onBack={onClose}
          onSuccess={onClose}
          source={source}
          companies={companies}
          balanceAmount={balanceAmount}
        />
      </DialogContent>
    </Box>
  );
};

export default AddCompanyDialog;
